import {Fragment} from "react";
import {DatePicker} from "react-advance-jalaali-datepicker";

const DatePickerComponent = ({preSelected, handleChange, label}) => {

    return(
        <Fragment >
            <div dir="rtl" className='relative [&_input]:input-styles [&_input]:py-[6px] [&_input]:cursor-pointer text-xs [&_input]:w-[140px]
                           [&_input]:hover:border-green-500 [&_input]:w-[30vw] sm:[&_input]:w-[15vw] md:[&_input]:w-[12vw] xl:[&_input]:w-[10vw]'
            >
                <DatePicker cancelOnBackgroundClick format="jYYYY/jMM/jDD" placeholder='تاریخ' preSelected={preSelected}
                            controlValue={true} inputTextAlign='center' onChange={handleChange}
                            customClass={`border border-2 border-green-500 rounded-2xl p-3 [&_.number]:border [&_.number]:border-2
                            [&_span]:text-red-400 ${label === ':از' ? '-left-[150%]' : '-left-[20%]'}`}
                />
                <i className="fa fa-calendar absolute top-[30%] left-[5%] pointer-events-none" aria-hidden="true"></i>
            </div>
            <span className='text-xs'>{label}</span>
        </Fragment>
    )
}

export default DatePickerComponent